"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _ArrowDropDown = _interopRequireDefault(require("@mui/icons-material/ArrowDropDown"));
var _locale = require("date-fns/locale");
var _components = require("../components");
var _daterange = require("../daterange");
var _validators = require("../validators");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function AnyDateRange(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? 'dense' : _ref$margin,
    _ref$defaultFormat = _ref.defaultFormat,
    defaultFormat = _ref$defaultFormat === void 0 ? _components.PICKER_DATE_FORMAT : _ref$defaultFormat,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? _locale.es : _ref$locale,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    name = _ref.name,
    label = _ref.label,
    initialValue = _ref.initialValue,
    required = _ref.required,
    disabled = _ref.disabled,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    register = _ref.register,
    notifier = _ref.notifier,
    menuItemsCustom = _ref.menuItemsCustom;
  var formatValue = (0, _react.useCallback)(function (startDate, endDate) {
    return "".concat((0, _components.formatDate)({
      date: startDate,
      pattern: defaultFormat,
      locale: locale
    }), " - ").concat((0, _components.formatDate)({
      date: endDate,
      pattern: defaultFormat,
      locale: locale
    }));
  }, [defaultFormat, locale]);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    blured = _useState2[0],
    setBlured = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    valid = _useState4[0],
    setValid = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dirty = _useState6[0],
    setDirty = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    value = _useState10[0],
    setValue = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    _useState12 = _slicedToArray(_useState11, 2),
    dateRanges = _useState12[0],
    setDateRanges = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    gridAnchorEl = _useState14[0],
    setGridAnchorEl = _useState14[1];
  var ref = (0, _react.useRef)({
    valid: valid,
    dirty: dirty,
    value: value,
    setBlur: function setBlur() {
      return setBlured(true);
    }
  });
  var onClosePopup = (0, _react.useCallback)(function () {
    setGridAnchorEl(null);
  }, []);
  var onShowPopup = (0, _react.useCallback)(function (event) {
    if (disabled) return;
    setGridAnchorEl(event.currentTarget);
  }, [disabled]);
  var onChanged = (0, _react.useCallback)(function (value) {
    onClosePopup();
    if (value) {
      setDirty(true);
      setDateRanges(formatValue(value.startDate, value.endDate));
      setValue(value);
    } else {
      setDirty(false);
      setDateRanges('');
      setValue(undefined);
    }
  }, [formatValue, onClosePopup]);
  var inputBlured = (0, _react.useCallback)(function (_event) {
    if (!blured) {
      setBlured(true);
    }
  }, [blured]);
  var onNotify = (0, _react.useCallback)(function (value) {
    if (notifier) {
      notifier(name, value);
    }
  }, [notifier, name]);
  (0, _react.useEffect)(function () {
    var valid = !required || !!value && !!value.startDate && !!value.endDate;
    var error = valid ? undefined : _validators.TEXT_REQUIRED_VALIDATOR.getMessage();
    ref.current.valid = valid;
    ref.current.dirty = dirty;
    ref.current.value = value;
    setValid(valid);
    setError(error);
    onNotify(value);
  }, [value, dirty, required, onNotify]);
  (0, _react.useEffect)(function () {
    register(name, ref.current);
  }, [register, name, ref]);
  (0, _react.useEffect)(function () {
    if (initialValue) {
      setDateRanges(formatValue(initialValue.startDate, initialValue.endDate));
      setValue(initialValue);
    }
  }, [initialValue, formatValue]);
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    variant: variant,
    size: size,
    margin: margin,
    name: name,
    label: label,
    value: dateRanges,
    required: required,
    disabled: disabled,
    fullWidth: fullWidth,
    error: blured && !valid,
    helperText: blured ? error : undefined,
    onBlur: inputBlured,
    onClick: onShowPopup,
    InputProps: {
      readOnly: true,
      endAdornment: /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], {
        sx: {
          mr: -0.6
        }
      })
    }
  }), gridAnchorEl && (/*#__PURE__*/_react["default"].createElement(_daterange.DateRangeDialog, {
    anchorEl: gridAnchorEl,
    initialValue: value,
    locale: locale,
    maxDate: maxDate,
    minDate: minDate,
    menuItemsCustom: menuItemsCustom,
    onChanged: onChanged,
    onClose: onClosePopup
  })));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AnyDateRange);